import { ISofaTaskPaneStrings } from "./myStrings.model";

export const EN = (): ISofaTaskPaneStrings => {
  return {
    // Add to sofa strings
    documentTypesLabel: "Document types",
    documentTypesPlaceholder: "Select one option",
    isDocumentClosed: "Is document closed",
    back: "Back",
    buttonSubmit: "Add to sofa",
    // Common strings
    initializedErrorMessage: "Something went wrong or you have no access to Sofa. Try it again, please.",
    buttonCancel: "Cancel",
    noAccessToSofa: "Unable to get data, check your access to Sofa please.",
    noLogin: "There was a problem getting the document name, you must be logged in for the add-in to work properly.",
    open: "Open",
    save: "Save",
    // Dialog box strings
    dialogValidationTitle: "Form validation",
    dialogValidationSubtitle: "Please fill all the required fields.",
    dialogSuccessTitle: "Success",
    dialogSuccessSubtitle: "Your document has been successfully submitted into Sofa 602.",
    dialogErrorTitle: "Error",
    dialogErrorSubtitle: "There was an issue while submitting your document. Please try it again.",
    errorMessageFieldName: "Maximum name length is 255",
    dialogPopUpWarning: "Enable pop-up windows for this webpage to display the agenda.",
    // Agenda strings
    agendaTitle: "Start agenda",
    agendaSuccessfullyStarted: "Agenda successfully started; you can continue in tab of your default browser.",
    archiveTitle: "Send to archive",
    errorTitle: "Error",
    // Sign Point strings
    signPointTitle: "Signing document",
    // ISDS strings
    sendToISDSTitle: "Sending to ISDS",
    isdsIsNotAvailable: "Agenda send to ISDS is not available.",
    // Send to agenda strings
    classifyFile: "File classification",
    getFileId: "Creating file ID",
    orderAgenda: "Order agenda",
    orderAgendaText: "You do not Sofa SignPoint agenda active.",
    savingFile: "Saving file",
    startSignPoint: "Starting agenda",
    // signed agenda states
    error: "An error occurred during signing, please try again.",
    info: "Signing in progress.",
    severeWarning: "Operation expired, document not signed",
    success: "The signing has been successfully completed.",
    warning: "The event has been cancelled, the signing form has been closed.",
  };
};
